import { connect } from 'react-redux';
import { ExpandableMenuItem } from 'tradera/components/site-header/dropdown-menu-item-expandable';
import { CurrencySelect } from 'tradera/components/localization/currency-select';
import CurrencyIcon from '@tradera/blueprint/theme/icons2/currency.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import {
    selectShowCurrencySelection,
    selectPreferredCurrency,
} from 'tradera/state/multi-currency/selectors';

export const PlainCurrencyMenuItem = ({
    onToggle,
    showCurrencySelection,
    preferredCurrency,
}) => {
    const { t } = useTranslator();

    return showCurrencySelection ? (
        <ExpandableMenuItem
            label={t('siteHeader_currencyWithShortName', {
                currencyShortName: preferredCurrency.shortName,
            })}
            border
            icon={<CurrencyIcon className="icon-md" />}
            onOpen={onToggle}
            onClose={onToggle}>
            <CurrencySelect inProfileMenu={true} />
        </ExpandableMenuItem>
    ) : null;
};

const mapStateToProps = (state) => ({
    showCurrencySelection: selectShowCurrencySelection(state),
    preferredCurrency: selectPreferredCurrency(state),
});

export const CurrencyMenuItem = connect(mapStateToProps)(PlainCurrencyMenuItem);
